import React, { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

const navLinkClass = ({ isActive }: { isActive: boolean }) =>
  `px-3 py-2 rounded-md text-sm font-medium transition-colors ${
    isActive
      ? 'bg-blue-600 text-white'
      : 'text-slate-200 hover:bg-slate-700 hover:text-white'
  }`;

const Layout: React.FC = () => {
  const { staff, logout } = useAuth();
  const navigate = useNavigate();
  const [quickLookup, setQuickLookup] = useState('');

  const onQuickLookup = (e: React.FormEvent) => {
    e.preventDefault();
    const code = quickLookup.trim();
    if (code) {
      navigate(`/students/${code.toUpperCase()}`);
      setQuickLookup('');
    }
  };

  return (
    <div className="min-h-screen bg-slate-100">
      <header className="bg-slate-900 text-white">
        <div className="mx-auto max-w-7xl px-4">
          <div className="flex h-14 items-center justify-between gap-4">
            <div className="flex items-center gap-3">
              <span className="text-sm font-semibold tracking-wide text-white">
                FL DOH ADMIN
              </span>
              {staff && (
                <span className="hidden text-xs text-slate-300 sm:inline">
                  Region: {staff.county_code} · {staff.first_name} {staff.last_name} (
                  {staff.role.replace('_', ' ')})
                </span>
              )}
            </div>

            <div className="flex items-center gap-3">
              <form onSubmit={onQuickLookup} className="flex items-center">
                <input
                  type="text"
                  value={quickLookup}
                  onChange={(e) => setQuickLookup(e.target.value)}
                  placeholder="Student Code (STU-XXXX)"
                  className="rounded-l-md border border-slate-700 bg-slate-800 px-2.5 py-1 text-xs text-white placeholder-slate-400 focus:border-blue-500 focus:outline-none w-44 sm:w-56"
                />
                <button
                  type="submit"
                  className="rounded-r-md bg-blue-600 px-2.5 py-1 text-xs font-semibold text-white hover:bg-blue-700 transition-colors"
                >
                  Lookup
                </button>
              </form>

              <button
                onClick={logout}
                className="rounded-md border border-slate-600 px-3 py-1 text-xs font-medium text-slate-200 hover:bg-slate-700"
              >
                Log Out
              </button>
            </div>
          </div>
          <nav className="flex gap-2 pb-2">
            <NavLink to="/" end className={navLinkClass}>
              Dashboard
            </NavLink>
            <NavLink to="/directory" className={navLinkClass}>
              Student Directory
            </NavLink>
            <NavLink to="/shots" className={navLinkClass}>
              SHOTS Bridge
            </NavLink>
            <NavLink to="/reports" className={navLinkClass}>
              DOH Reports
            </NavLink>
          </nav>
        </div>
      </header>

      <main className="mx-auto max-w-7xl px-4 py-6">
        <Outlet />
      </main>

      <footer className="mx-auto max-w-7xl px-4 py-6 text-center text-xs text-slate-500">
        All activity is monitored and logged per
        SOC 2 standards and Florida Statutes § 381.003.
      </footer>
    </div>
  );
};

export default Layout;
